import React, { useEffect, useRef, useState } from "react";
import { CiMenuKebab } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import { IoDuplicateOutline } from "react-icons/io5";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { FaEdit, FaHistory, FaRegEdit, FaTrash } from "react-icons/fa";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { Badge, Col, Collapse, Container, Form, ListGroup, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import SplitPane from "react-split-pane";
import UpdateStudyLabFile from "./UpdateStudyLabFile";
import UploadStudyLabFile from "./UploadStudyLabFile";
import { studyLabManagementFileServices } from "../../../../APIServices/studyLabManagementFileServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { useParams } from "react-router";
import UseToggle from "../../../../Hooks/UseToggle";
import DeletedStudyLabManagement from "./DeletedStudyLabManagement";
import StudyLabManagementActivities from "./StudyLabManagementActivities";
import ReadS3TableData from "../ReadS3TableData";
import Moment from "react-moment";

const StudyLabFileManagement = ({ tableRef, onMouseDown }) => {
  const [fileId, setFileId] = useState("");
  const [fileData, setFileData] = useState("");
  const [loading, setLoading] = useState(false);
  const [openOption, setOpenOption] = useState(false);

  const [fileList, setFileList] = useState([]);

  const [deletedStudyLabManagement, setDeletedStudyLabManagement] = useState([]);
  const [deletedStudyLabManagementCount, setDeletedStudyLabManagementCount] = useState(0);

  const [fileActivity, setFileActivity] = useState([]);
  const [fileActivityCount, setFileActivityCount] = useState(0);
  const [activityLoader, setActivityLoader] = useState(false);

  const { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2, toggle3, setToggle3 } = UseToggle();
  const AppsRef = useRef(null);

  const getStudyLabManagementData = async (e) => {
    setLoading(true);
    let data = await studyLabManagementFileServices.getStudyLabManagementData("active", studyId, StudyMode);
    setFileList(data?.data || []);
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedStudyLabManagement = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await studyLabManagementFileServices.getStudyLabManagementData(
      "deleted",
      studyId,
      StudyMode,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedStudyLabManagement(data?.data || []);
    setDeletedStudyLabManagementCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "studyLabManagementFile",
      studyId,
      fileId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setFileActivity(data?.data || []);
    setFileActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  useEffect(() => {
    getStudyLabManagementData();
  }, []);

  const softDeleteRestoreStudyLabManagement = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} Study Lab File!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        let data =
          await studyLabManagementFileServices.softDeleteRestoreStudyLabManagement(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyLabManagementData();
          setFileData("");
          getDeletedStudyLabManagement();
          if (type === "restore") {
            getDeletedStudyLabManagement(pageNumberDeleted, itemsPerPageDeleted);
            setToggle2();
          }
        }
      }
    });
  };

  const formatFileSize = (bytes) => {
    if (!bytes || bytes <= 0) return "0 Bytes";

    const units = ["Bytes", "KB", "MB", "GB", "TB"];
    let size = Number(bytes);
    let unitIndex = 0;

    while (size >= 1024 && unitIndex < units.length - 1) {
      size /= 1024;
      unitIndex++;
    }

    const formatted =
      size >= 100
        ? size.toFixed(0)
        : size % 1 === 0
          ? size.toFixed(0)
          : size.toFixed(2);

    return `${formatted} ${units[unitIndex]}`;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setOpenOption(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <>
      <SplitPane split="vertical" minSize={"20%"} className="position-relative" style={{ height: "calc(100vh - 142px)" }}>
        <div>
          <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
            <button
              onClick={setToggle2}
              className={`removeProfile`}
            >
              Deleted File
            </button>
            <button
              onClick={setToggle}
              className={`updateProfile`}
            >
              Upload New File
            </button>
          </div>
          <div className="overflow-auto" style={{ height: "calc(100vh - 182px)" }}>
            {loading ? (
              <PageLoader />
            ) : fileList?.length === 0 ? (
              <NoDataFoundTable MSG={"Study Lab File not found!"} />
            ) : (
              <div className="p-2">
                <ListGroup>
                  {fileList.map((file, index) => {
                    const isActive = file?.fileId === fileId;
                    const isMenuOpen = openOption === index;
                    return (
                      <>
                        <ListGroup.Item action
                          title={file?.fileName}
                          onClick={() => setFileData(file)}
                          key={file?.fileId || index}
                          className={`hstack justify-content-between p-0 ${fileData?.fileId === file?.fileId && "selectedMenu"}`}
                        >
                          <div style={{ padding: "5px 10px 7px 10px" }} ref={AppsRef}>
                            <span>{file?.fileName}</span>
                            <small className="d-block" style={{ fontSize: 10 }}><b>Size:</b> {formatFileSize(file?.size)}</small>
                            <small className="d-block" style={{ fontSize: 10 }}><b>Form:</b> {`${file?.formName} (v${file?.formVersion})`}</small>
                            <small className="d-block text-capitalize" style={{ fontSize: 10 }}><b>Dataset Type:</b> {file.datasetType}</small>
                            <small className="d-block" style={{ fontSize: 10 }}><b>Modified DT:</b> <Moment format="DD MMM YYYY | HH:mm" withTitle>{file.updatedAt}</Moment></small>
                          </div>
                          <div className="position-relative" style={{ padding: "5px 10px 7px 10px" }} title="Open Action">
                            <div
                              onClick={(e) => {setOpenOption(isMenuOpen ? null : index); e.stopPropagation() }}
                              className={`${isActive ? "btn-active text-white" : "btn-outline-secondary"}`}
                            >
                              <CiMenuKebab />
                            </div>
                            <Collapse in={isMenuOpen === true}>
                              <div className="position-absolute end-0 z-1" style={{ top: 36 }}>
                                <ListGroup className="br3" style={{ fontSize: 12 }}>
                                  <ListGroup.Item onClick={() => { setFileData(file); setToggle1() }} action className="text-nowrap py-1 px-3 text-primary"><FaEdit className="mb-1 me-1" /> Edit</ListGroup.Item>
                                  <ListGroup.Item onClick={() => softDeleteRestoreStudyLabManagement(file?._id, "delete")} action className="text-nowrap py-1 px-3 text-danger"><FaTrash className="mb-1 me-1" /> Delete</ListGroup.Item>
                                  <ListGroup.Item onClick={() => { setFileId(file?.fileId); setToggle3() }} action className="text-nowrap py-1 px-3 text-primary"><FaHistory className="mb-1 me-1" /> Activities</ListGroup.Item>
                                </ListGroup>
                              </div>
                            </Collapse>
                          </div>
                        </ListGroup.Item>
                      </>
                    );
                  })}
                </ListGroup>
              </div>
            )}
          </div>
        </div>
        {!fileData ?
          <div className="hstack justify-content-center h-100 fw-bold text-muted">
            First Click Any Lab File!
          </div>
          :
          <ReadS3TableData
            fileData={fileData}
            s3Url={fileData?.fileUrl}
            onMouseDown={onMouseDown}
            tableRef={tableRef}
            getStudyLabManagementData={getStudyLabManagementData}
          />
        }
      </SplitPane>
      <UploadStudyLabFile
        Show={!toggle}
        Hide={setToggle}
        Title={"Upload New Lab File"}
        getStudyLabManagementData={getStudyLabManagementData}
      />
      <UpdateStudyLabFile
        Show={!toggle1}
        Hide={setToggle1}
        fileData={fileData}
        Title={"Update Lab File Name and Level"}
        getStudyLabManagementData={getStudyLabManagementData}
      />
      <DeletedStudyLabManagement
        Show={!toggle2}
        Hide={setToggle2}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedStudyLabManagement={deletedStudyLabManagement}
        getDeletedStudyLabManagement={getDeletedStudyLabManagement}
        deletedStudyLabManagementCount={deletedStudyLabManagementCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreStudyLabManagement={softDeleteRestoreStudyLabManagement}
        Title={"Deleted Study Lab File History"}
      />
      <StudyLabManagementActivities
        Show={!toggle3}
        Hide={setToggle3}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        fileActivity={fileActivity}
        activityLoader={activityLoader}
        getStudyAuditTrials={getStudyAuditTrials}
        fileId={fileId}
        fileActivityCount={fileActivityCount}
        Title={"Study Lab File Activities"}
      />
    </>
  );
};

export default StudyLabFileManagement;
